import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const Project = ({ name, description, techStack, githubUrl, liveUrl }) => {
    return (
        <div className="project-card">
            <h3 className="project-name">{name}</h3>
            <p className="project-description">{description}</p>
            <div className="project-tech">
                {techStack.map((tech, i) => (
                    <span key={i} className="tech-tag">{tech}</span>
                ))}
            </div>
            <div className="project-links">
                {githubUrl && (
                    <a href={githubUrl} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaGithub /> GitHub
                    </a>
                )}
                {liveUrl && (
                    <a href={liveUrl} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaExternalLinkAlt /> Live Demo
                    </a>
                )}
            </div>
        </div>
    );
};

export default Project;
